// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__1YDSW","root-container":"classes_root-container__dfd4k","wrongchain-text":"classes_wrongchain-text__2jW61"};